"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var local_storage_1 = require("../utils/local-storage");
var VOD_API_URL_LS_KEY = 'VOD_API_URL';
exports.getVODApiUrl = function (fallbackUrl) {
    return local_storage_1.browserLocalStorage.getItem(VOD_API_URL_LS_KEY) || fallbackUrl;
};
//# sourceMappingURL=get-vod-api-url.js.map